/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Theme props for Wizard component
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

export const headerStepCircleSize = '28px';

export const modalSummaryPopupWidth = '380px';
